var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footerbar",attrs:{"id":"bottom"}},[_c('div',{staticClass:"footerbar-item has-text-centered"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/footer_logo.png"),"alt":"The Home Depot Pro - A Home Depot Company"}})])])])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d958790","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterLogo.vue
// module id = null
// module chunks = 